import { Injectable } from '@angular/core';
import { SnackBarType } from '@planone/shared/util-interfaces';
import { BehaviorSubject, Observable, share } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  readonly notificationContent$: Observable<{
    message: string;
    type: string;
    action: string | undefined;
    closable: boolean | undefined;
  }>;

  private templateRef$: BehaviorSubject<{
    message: string;
    type: string;
    action: string | undefined;
    closable: boolean | undefined;
  }> = new BehaviorSubject<{
    message: string;
    type: string;
    action: string | undefined;
    closable: boolean | undefined;
  }>({
    message: '',
    type: SnackBarType.failure,
    action: undefined,
    closable: false,
  });

  constructor() {
    this.notificationContent$ = this.templateRef$.asObservable().pipe(share());
  }

  projectContent(
    notificationMessage: string,
    notificationType: SnackBarType = SnackBarType.failure,
    notificationAction: string | undefined = undefined,
    notificationClosable = true
  ) {
    this.templateRef$.next({
      message: notificationMessage,
      type: notificationType,
      action: notificationAction,
      closable: notificationClosable,
    });
  }
}
